import DetailPage from './DetailPage'

export default DetailPage
// eslint-disable-next-line import/export
export * from './DetailPage'
